// extracted by mini-css-extract-plugin
module.exports = {"container":"classes_container__2Bjlm","personal":"classes_personal__MGq8m","name":"classes_name__2A__X","ul":"classes_ul__23pNP","skills":"classes_skills__2d-s8"};